import { BONUS_TERMS_VIEW } from './types';

export const triggerBonusTermsIsViewed = deals => ({
  type: BONUS_TERMS_VIEW,
  deals,
});
